import React, { useContext } from "react";
import { Col } from "react-bootstrap";
import { ThemeContext } from "../../App";
import { motion } from "framer-motion";

const CertCard = ({ data, index }) => {
  const { theme } = useContext(ThemeContext);
  
  return (
    <Col lg="6" md="6" sm="12">
      <motion.div
        className="pb-5 text-center"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ 
          duration: 0.45, 
          delay: index * 0.06,
          ease: [0.4, 0, 0.2, 1]
        }}
      >
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          style={{ display: 'inline-block' }}
        >
          <img
            className="mb-3"
            src={theme === "light" ? data.badgeLight : data.badgeDark}
            alt={data.certname}
            height={258}
            width={258}
            style={{
              borderRadius: '16px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
              transition: 'all 0.3s ease'
            }}
          />
        </motion.div>
        
        <motion.p
          className="lead"
          style={{ fontWeight: 600, marginTop: '1rem', color: 'var(--text-primary)' }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.06 + 0.2 }}
        >
          {data.certname}
        </motion.p>
        
        <motion.p
          className="lead"
          style={{ 
            marginTop: "0.5rem",
            color: 'var(--text-secondary)',
            fontSize: '0.95rem'
          }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.06 + 0.25 }}
        >
          {data.date}
        </motion.p>
        
        <motion.a
          href={data.link}
          className={`btn ${
            theme === "light" ? "btn-outline-dark" : "btn-outline-light"
          } btn-lg`}
          role="button"
          aria-label="Verify"
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ 
            scale: 1.02,
            boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)"
          }}
          whileTap={{ scale: 0.97 }}
          style={{
            borderRadius: '12px',
            borderWidth: '2px',
            fontWeight: 600,
            marginTop: '1rem',
            padding: '0.5rem 2rem',
            transition: 'all 0.3s ease'
          }}
        >
          Verify
        </motion.a>
      </motion.div>
    </Col>
  );
};

export default CertCard;
